import axios from '../utils/API.js'
import {
  getFromLocalStorage,
  saveInLocalStorage,
} from 'Influencers/helper/storage'
import errorHandler from 'Influencers/helper/errorHandler'
import i18n from 'i18n'
import { RTL } from 'locales/currentLang'
import langUrl from '../utils/langUrl'
const getAllCountries = async () => await axios.get('countries')
const getCitiesForCountry = async id => await axios.get(`cities/${id}`)
const getObjectives = () => axios.get('objectives')
const getAudiences = () => axios.get('audiences')
const isAuthenticated = () => getFromLocalStorage('brandData:')
const isAuthenticatedInfluencer = () => getFromLocalStorage('userData:')
const unAuthenticatedUser = () =>
  !isAuthenticated() && !isAuthenticatedInfluencer()

const signUp = (
  user,
  setAuthError,
  setBrandData,
  setUserData,
  SuccessRegister,
  stopLoader,
  showVerification,
) => {
  axios
    .post('brands', user, { 'content-type': 'multipart/form-data' })
    .then(res => {
      if (res.data.data.user_id !== undefined) {
        showVerification()
        localStorage.setItem('user_id', res.data.data.user_id)
        //stopLoader()
      } else {
        setUserData(null)
        setAuthError(null)
        const currentLang = RTL()
        localStorage.clear()
        localStorage.setItem('i18nextLng', currentLang ? 'ar' : 'en')
        setBrandData(res.data.data)
        saveInLocalStorage('brandData:', res.data.data)
        axios.defaults.headers['Authorization'] =
          'Bearer' + ' ' + JSON.parse(localStorage.getItem('brandData:'))?.token
        SuccessRegister()
      }
    })
    .catch(e => {
      const { response } = e
      setBrandData(null)
      setUserData(null)
      const currentLang = RTL()
      localStorage.clear()
      saveInLocalStorage('brandData:', null)
      localStorage.setItem('i18nextLng', currentLang ? 'ar' : 'en')
      setAuthError(errorHandler(response))
      stopLoader()
    })
}
const signUpInfluencer = (
  user,
  setAuthError,
  setUserData,
  setBrandData,
  SuccessRegister,
  stopLoader,
  showVerification,
) => {
  axios
    .post('influencers', user)
    .then(res => {
      if (res.data.data.user_id !== undefined) {
        localStorage.setItem('user_id', res.data.data.user_id)
        showVerification()
        //stopLoader()
      } else {
        setBrandData(null)
        setAuthError(null)
        const currentLang = RTL()
        localStorage.clear()
        setUserData(res.data.data)
        saveInLocalStorage('userData:', res.data.data)
        localStorage.setItem('i18nextLng', currentLang ? 'ar' : 'en')
        axios.defaults.headers['Authorization'] =
          'Bearer' + ' ' + JSON.parse(localStorage.getItem('userData:'))?.token
        SuccessRegister()
      }
    })
    .catch(e => {
      const { response } = e
      setUserData(null)
      setBrandData(null)
      const currentLang = RTL()
      localStorage.clear()
      localStorage.setItem('i18nextLng', currentLang ? 'ar' : 'en')
      saveInLocalStorage('userData:', null)
      setAuthError(errorHandler(response))
      stopLoader()
    })
}
const login = (
  user,
  setAuthError,
  setBrandData,
  setUserData,
  SuccessBrandLogin,
  SuccessInfluencerLogin,
  stopLoader,
  showVerification,
) => {
  axios
    .post('login', user)
    .then(res => {
      if (res.data.data.user_id !== undefined) {
        localStorage.setItem('user_id', res.data.data.user_id)
        showVerification()
        //stopLoader()
      } else {
        setBrandData(null)
        setUserData(null)
        const currentLang = RTL()
        localStorage.clear()
        localStorage.setItem('i18nextLng', currentLang ? 'ar' : 'en')
        if (res.data.data.type === 'brand') {
          setBrandData(res.data.data)
          saveInLocalStorage('brandData:', res.data.data)
          axios.defaults.headers['Authorization'] =
            'Bearer' +
            ' ' +
            JSON.parse(localStorage.getItem('brandData:'))?.token
          SuccessBrandLogin()
        } else {
          setUserData(res.data.data)
          saveInLocalStorage('userData:', res.data.data)
          axios.defaults.headers['Authorization'] =
            'Bearer' +
            ' ' +
            JSON.parse(localStorage.getItem('userData:'))?.token
          SuccessInfluencerLogin()
        }
        setAuthError(null)
      }
    })
    .catch(e => {
      const { response } = e
      setBrandData(null)
      setUserData(null)
      const currentLang = RTL()
      localStorage.clear()
      localStorage.setItem('i18nextLng', currentLang ? 'ar' : 'en')
      setAuthError(errorHandler(response))
      stopLoader()
    })
}
const logout = (event, setBrandData, setUserData) => {
  event.preventDefault()
  axios.defaults.headers['Authorization'] = ''
  setBrandData(null)
  setUserData(null)
  //const currentLang = localStorage.getItem('i18nextLng')
  localStorage.removeItem('brandData:')
  localStorage.removeItem('userData:')
  // localStorage.clear()
  // saveInLocalStorage('i18nextLng', currentLang === 'ar' ? 'ar' : 'en')
}
const resendEmail = (email, Toast, hideLoader) => {
  axios
    .get(`/email/resend?email=${email}`)
    .then(res => {
      hideLoader()
      Toast(i18n.t('modal.email.resend-success'), {
        appearance: 'success',
        autoDismiss: true,
      })
    })
    .catch(e => {
      hideLoader()
      Toast(i18n.t('toast.error.social'), {
        appearance: 'error',
        autoDismiss: true,
      })
    })
}
const verifyEmail = (
  id,
  code,
  stopLoader,
  goHome,
  setBrandData,
  setUserData,
  Toast,
) => {
  axios
    .post(`user/verify/${id}`, { code })
    .then(res => {
      setBrandData(null)
      setUserData(null)
      const currentLang = RTL()
      localStorage.clear()
      localStorage.setItem('i18nextLng', currentLang ? 'ar' : 'en')
      if (res.data.data.type === 'brand') {
        setBrandData(res.data.data)
        saveInLocalStorage('brandData:', res.data.data)
        axios.defaults.headers['Authorization'] =
          'Bearer' + ' ' + JSON.parse(localStorage.getItem('brandData:'))?.token
        goHome()
      } else {
        setUserData(res.data.data)
        saveInLocalStorage('userData:', res.data.data)
        axios.defaults.headers['Authorization'] =
          'Bearer' + ' ' + JSON.parse(localStorage.getItem('userData:'))?.token
        goHome()
      }
    })
    .catch(err => {
      Toast(i18n.t('toast.error.social'), {
        appearance: 'error',
        autoDismiss: true,
      })
      stopLoader()
    })
}
const searchInfluencer = (keyword, setSearchResults, setShowList) => {
  if (keyword.name !== '') {
    axios
      .post('influencers/search-autocomplete', keyword)
      .then(res => {
        setSearchResults(res.data.data)
        setShowList(true)
      })
      .catch(e => {
        const { response } = e
        setSearchResults(null)
        setShowList(false)
      })
  } else {
    setSearchResults(null)
  }
}
const getRecommendedInfluencers = () => axios.get('influencers')
const createCampaign = (
  campaign,
  successCampaign,
  Toast,
  setError,
  stopLoader,
  history,
) => {
  axios
    .post('campaigns', campaign)
    .then(res => {
      setError(null)
      successCampaign()
      history.push({
        pathname: `/${langUrl}/brand/campaign/create/payment`,
        state: {
          id: res.data.data.id,
          total: res.data.data.total_cost,
        },
      })
      // Toast(i18n.t('toast.success.create-campaign'), {
      //   appearance: 'success',
      //   autoDismiss: true,
      // })
    })
    .catch(e => {
      const { response } = e
      setError(errorHandler(response))
      stopLoader()
    })
}
const campaignPay = (id, total, Toast) =>
  fetch(
    `https://jazeel-backend-staging.halayalla.rocks/payment?campaign=${id}&amount=${total}`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
      },
    },
  )
    .then(res => {
      res.json().then(data => {
        window.open(data.payment_url, '_self', 'width=500,height=500')
      })
    })
    .catch(e => {
      Toast(i18n.t('toast.error.social'), {
        appearance: 'error',
        autoDismiss: true,
      })
    })
const brandDashboard = () => axios.post('brands/dashboard')
const campaignDetails = (id, setDetails, setLoad) => {
  axios
    .get(`campaigns/${id}`)
    .then(res => {
      setDetails(res.data.data)
      setLoad(false)
    })
    .catch(e => {
      const { response } = e
      setDetails(null)
      setLoad(false)
    })
}
const profileData = () => axios.post('brands/get-brand-data')
const updateProfile = (profile, successUpdate, Toast, setError, stopLoader) => {
  axios
    .put(`brands/${profile.id}`, profile)
    .then(res => {
      setError(null)
      Toast(i18n.t('toast.success.update-profile'), {
        appearance: 'success',
        autoDismiss: true,
      })
      successUpdate()
    })
    .catch(e => {
      const { response } = e
      setError(errorHandler(response))
      stopLoader()
    })
}
const acceptInfluencer = (id, stopLoader, Toast, successAccept) =>
  axios
    .patch(`invitations/accept/${id}`)
    .then(res => {
      stopLoader()
      Toast(i18n.t('toast.success.accept-influencer'), {
        appearance: 'success',
        autoDismiss: true,
      })
      successAccept()
    })
    .catch(e => {
      stopLoader()
    })
const startCampaign = (id, stopLoader, setError, success) =>
  axios
    .post(`campaigns/lets_start_campaign/${id}`)
    .then(res => {
      setError(null)
      stopLoader()
      success()
    })
    .catch(e => {
      const { response } = e
      setError(errorHandler(response))
      stopLoader()
    })
const milestoneDetails = (id, setDetails, setLoad, setInput) => {
  axios
    .get(`milestones/${id}`)
    .then(res => {
      const details = res.data.data
      setDetails(details)
      if (setInput) {
        setInput({
          name: details.name,
          description: details.description,
          preferred_date: new Date(details.preferred_date),
          preferred_time: details.preferred_time,
        })
      }
      setLoad(false)
    })
    .catch(e => {
      const { response } = e
      setDetails(null)
      setLoad(false)
    })
}
const addMilestoneComment = (comment, setComments, comments) =>
  axios.post('milestones/comments', comment).then(res => {
    setComments([...comments, { ...res.data.data, pending: 0 }])
  })
const assignInfluencerToMilestone = (
  milestone,
  influencer,
  Toast,
  hideModal,
  setInfluencer,
  finishProcess,
) =>
  axios
    .post('milestones/assign_influencer', {
      milestone,
      influencer: influencer.id,
    })
    .then(res => {
      Toast(i18n.t('toast.success.assign-influencer'), {
        appearance: 'success',
        autoDismiss: true,
      })
      finishProcess()
      hideModal()
      setInfluencer(influencer.name)
    })
    .catch(e => {
      Toast(i18n.t('toast.error.assign-influencer'), {
        appearance: 'error',
        autoDismiss: true,
      })
      finishProcess()
      hideModal()
    })
const updateMilestone = (
  milestone,
  id,
  Toast,
  // hideModal,
  finishProcess,
  // successfullyUpdated,
) =>
  axios
    .put(`milestones/${id}`, {
      ...milestone,
    })
    .then(res => {
      Toast(i18n.t('toast.success.update-milestone'), {
        appearance: 'success',
        autoDismiss: true,
      })
      finishProcess()
      // hideModal()
      // successfullyUpdated()
    })
    .catch(e => {
      Toast(i18n.t('toast.error.update-milestone'), {
        appearance: 'error',
        autoDismiss: true,
      })
      finishProcess()
      // hideModal()
    })
const changeMilestoneStatus = (
  milestone,
  status,
  Toast,
  finishRequest,
  completeFromBrand,
) =>
  axios
    .post('milestones/changestatus', { milestone, status })
    .then(res => {
      Toast(i18n.t('toast.success.change-milestone'), {
        appearance: 'success',
        autoDismiss: true,
      })
      finishRequest()
      if (completeFromBrand) {
        completeFromBrand()
      }
    })
    .catch(e => {
      Toast(i18n.t('toast.error.change-milestone'), {
        appearance: 'error',
        autoDismiss: true,
      })
      finishRequest()
    })
const getAllAcceptedInfluencers = campaignId =>
  axios.get(`campaigns/influencers/${campaignId}`)

const influencerDashboard = () => axios.post('influencers/dashboard')
const campaignRequests = () =>
  axios.get('influencers/get-influencer-all-campaigns-requests')
const influencerCampaignDetails = (id, setDetails, setLoad) => {
  axios
    .get(`influencers/campaign/${id}`)
    .then(res => {
      setDetails(res.data.data)
      setLoad(false)
    })
    .catch(e => {
      const { response } = e
      setDetails(null)
      setLoad(false)
    })
}
const influencerAcceptCampaign = (id, setLoad, successRedirect, setError) => {
  axios
    .patch(`invitations/approve/${id}`)
    .then(res => {
      setError(null)
      setLoad(false)
      // setModalShow(true)
      successRedirect()
    })
    .catch(e => {
      const { response } = e
      setError(errorHandler(response))
      setLoad(false)
    })
}
const influencerRejectCampaign = (id, setLoad, Toast, back, setError) => {
  axios
    .patch(`invitations/reject/${id}`)
    .then(res => {
      setError(null)
      setLoad(false)
      Toast(i18n.t('toast.success.reject-campaign'), {
        appearance: 'success',
        autoDismiss: true,
      })
      back()
    })
    .catch(e => {
      const { response } = e
      setError(errorHandler(response))
      setLoad(false)
    })
}
const influencerPricing = () => axios.post('influencers/getpricelist')
const updateinfluencerPricing = (
  profile,
  successUpdate,
  Toast,
  setError,
  stopLoader,
) => {
  axios
    .post(`influencers/pricelist`, profile)
    .then(res => {
      setError(null)
      stopLoader()
      Toast(i18n.t('toast.success.update-price'), {
        appearance: 'success',
        autoDismiss: true,
      })
      successUpdate()
    })
    .catch(e => {
      const { response } = e
      setError(errorHandler(response))
      stopLoader()
    })
}
const influencerAttributes = () =>
  axios.post('influencers/getaudienceAttribute')
const updateinfluencerAttributes = (
  profile,
  successUpdate,
  Toast,
  setError,
  stopLoader,
) => {
  axios
    .post(`influencers/audienceAttribute`, profile)
    .then(res => {
      setError(null)
      stopLoader()
      Toast(i18n.t('toast.success.update-attribute'), {
        appearance: 'success',
        autoDismiss: true,
      })
      successUpdate()
    })
    .catch(e => {
      const { response } = e
      setError(errorHandler(response))
      stopLoader()
    })
}
const influencerProfileData = () =>
  axios.post('influencers/get-influencer-data')
const updateInfluencerProfile = (
  profile,
  successUpdate,
  Toast,
  setError,
  stopLoader,
) => {
  axios
    .put('influencers/update', profile)
    .then(res => {
      setError(null)
      Toast(i18n.t('toast.success.update-profile'), {
        appearance: 'success',
        autoDismiss: true,
      })
      successUpdate()
    })
    .catch(e => {
      const { response } = e
      setError(errorHandler(response))
      stopLoader()
    })
}
const updateAvatar = (
  image,
  successUpdate,
  Toast,
  setError,
  stopLoader,
  setData,
  prevData,
) => {
  axios
    .post('update_profile_photo', image)
    .then(res => {
      setError(null)
      Toast(i18n.t('toast.success.update-avatar'), {
        appearance: 'success',
        autoDismiss: true,
      })
      setData({ ...prevData, image: res.data.data.token })
      if (prevData.type === 'brand') {
        saveInLocalStorage('brandData:', {
          ...prevData,
          image: res.data.data.token,
        })
      } else {
        saveInLocalStorage('userData:', {
          ...prevData,
          image: res.data.data.token,
        })
      }

      successUpdate()
      stopLoader()
    })
    .catch(e => {
      const { response } = e
      setError(errorHandler(response))
      stopLoader()
    })
}

const updateSocialMedia = (profile, Toast, disconnect) => {
  axios
    .post(`/influencers/update-social-media`, profile)
    .then(res => {
      if (disconnect) {
        disconnect()
      }
    })
    .catch(e => {
      const { response } = e
      Toast(i18n.t('toast.error.social'), {
        appearance: 'error',
        autoDismiss: true,
      })
    })
}
const getTopInfluencers = (setDetails, Toast) => {
  axios
    .post('influencers/get-top-influencer', { status: 'top-x', limit: 4 })
    .then(res => {
      setDetails(res.data.data)
    })
    .catch(e => {
      const { response } = e
      setDetails(null)
      Toast(i18n.t('toast.error.social'), {
        appearance: 'error',
        autoDismiss: true,
      })
    })
}
const getRandomInfluencers = setDetails => {
  axios
    .post('influencers/get-top-influencer', { status: 'random', limit: 8 })
    .then(res => {
      setDetails(res.data.data)
    })
    .catch(e => {
      const { response } = e
      setDetails(null)
    })
}
const searchInfluencersIntro = (setDetails, name, audience) => {
  axios
    .post('influencers/get-top-influencer', {
      limit: 20,
      name: name ? name : null,
      audience: audience ? audience : null,
    })
    .then(res => {
      setDetails(res.data.data)
    })
    .catch(e => {
      const { response } = e
      setDetails(null)
    })
}
const getCategories = () => axios.get('/audiences')

export {
  signUp,
  signUpInfluencer,
  getAllCountries,
  getCitiesForCountry,
  login,
  logout,
  resendEmail,
  verifyEmail,
  isAuthenticated,
  isAuthenticatedInfluencer,
  unAuthenticatedUser,
  getObjectives,
  getAudiences,
  searchInfluencer,
  getRecommendedInfluencers,
  createCampaign,
  campaignPay,
  brandDashboard,
  campaignDetails,
  profileData,
  updateProfile,
  influencerDashboard,
  campaignRequests,
  influencerCampaignDetails,
  influencerAcceptCampaign,
  influencerRejectCampaign,
  influencerPricing,
  updateinfluencerPricing,
  acceptInfluencer,
  startCampaign,
  milestoneDetails,
  addMilestoneComment,
  getAllAcceptedInfluencers,
  assignInfluencerToMilestone,
  changeMilestoneStatus,
  influencerAttributes,
  updateinfluencerAttributes,
  influencerProfileData,
  updateInfluencerProfile,
  updateAvatar,
  updateSocialMedia,
  updateMilestone,
  getTopInfluencers,
  getRandomInfluencers,
  searchInfluencersIntro,
  getCategories,
}
